import { AlertCircle, Mail } from "lucide-react";

/**
 * Friendly catch-all for portal-side auth failures: expired link, invalid
 * token, signed out, etc. Care Seekers should never see the staff /login.
 */
export default function PortalExpired() {
  return (
    <div className="min-h-screen bg-[#F9F8F6] flex items-center justify-center p-6" data-testid="portal-expired-page">
      <div className="bg-white border border-[#E5E5E0] rounded-2xl shadow-sm max-w-md w-full p-8 text-center">
        <div className="w-14 h-14 rounded-2xl bg-[#FEE2E2] text-[#991B1B] mx-auto mb-4 flex items-center justify-center">
          <AlertCircle className="w-7 h-7" strokeWidth={1.75} />
        </div>
        <h1 className="font-display text-2xl font-semibold text-[#0F172A]">
          Sign-in link unavailable
        </h1>
        <p className="text-sm text-[#334155] mt-3">
          Your link may have expired or already been replaced by a newer one.
          Ask your HarborWell Care Navigator to send you a fresh sign-in email.
        </p>
        <a
          href="mailto:contact@harborwell.care"
          className="mt-6 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-[#1E3A8A] text-white text-sm font-medium hover:bg-[#172554]"
          data-testid="portal-expired-contact"
        >
          <Mail className="w-4 h-4" /> Contact HarborWell
        </a>
      </div>
    </div>
  );
}
